import React from "react";
import "./GlobalCallBar.css";

export default function GlobalCallBar({
  peer,
  callDuration,
  isMuted,
  onToggleMute,
  onEnd,
  onExpand,
}) {
  if (!peer) return null;

  const seconds = callDuration || 0;
  const mins = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const secs = (seconds % 60).toString().padStart(2, "0");

  return (
    <div
      className="global-call-bar"
      style={{
        position: "fixed",
        top: "var(--global-call-bar-top, env(safe-area-inset-top, 0px))",
        left: 50,
        right: 0,
        zIndex: 10000,
        background: "#111827",
        color: "#e5e7eb",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 12px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
      }}
      onClick={onExpand}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span style={{ fontWeight: 600 }}>
          {peer.name || "In Call"}
        </span>
        <span style={{ fontSize: "0.8rem", opacity: 0.8 }}>
          {peer.agency || ""}
        </span>
        <span style={{ fontSize: "0.75rem", opacity: 0.7 }}>
          {mins}:{secs}
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onToggleMute}
          style={{
            padding: "4px 8px",
            borderRadius: 4,
            border: "none",
            background: isMuted ? "#fbbf24" : "#4b5563",
            color: "#fff",
            fontSize: "0.8rem",
          }}
        >
          {isMuted ? "Unmute" : "Mute"}
        </button>
        <button
          onClick={onEnd}
          style={{
            padding: "4px 10px",
            borderRadius: 999,
            border: "none",
            background: "#ef4444",
            color: "#fff",
            fontSize: "0.8rem",
          }}
        >
          End
        </button>
      </div>
    </div>
  );
}
